import { isSameDay, isSameMonth, format } from "date-fns";
import { de } from "date-fns/locale";

const date = {
  de: {
    day: "d",
    dayMonth: "d. MMM",
    dayMonthYear: "d. MMM yyyy",
  },
  en: {
    day: "d",
    dayMonth: "MMM d",
    dayMonthYear: "MMM d, yyyy",
  },
};

/**
 * Renders a user-friendly version of the event time span
 *
 * @param {string} startTimestamp - UTC timestamp of the start date
 * @param {string} endTimestamp - UTC timestamp of the end date
 * @param {string} loc - String indication of the locale
 */

export const renderEventDate = (startTimestamp, endTimestamp, loc = "de") => {
  const start = new Date(startTimestamp);
  const end = new Date(endTimestamp);
  const oneDayEvent = isSameDay(start, end);
  const sameMonth = isSameMonth(start, end);
  const delimiter = " – ";

  const language = { locale: loc === "de" && de };

  if (oneDayEvent) {
    return format(start, date[loc].dayMonthYear, language);
  } else {
    if (sameMonth) {
      return (
        format(start, date[loc].day, language) +
        delimiter +
        format(end, date[loc].dayMonthYear, language)
      );
    } else {
      return (
        format(start, date[loc].dayMonth, language) +
        delimiter +
        format(end, date[loc].dayMonthYear, language)
      );
    }
  }
};
